export default __webpack_public_path__ + "static/media/icon-right.e37fec01.svg";